import pic31 from './assets/images/31.jpg';
import pic32 from './assets/images/32.jpg';
import pic33 from './assets/images/33.jpg';
import pic34 from './assets/images/34.jpg';

import svg11 from './assets/svg/11.svg';
import svg15 from './assets/svg/15.svg';
import svg31 from './assets/svg/31.svg';
import svg32 from './assets/svg/32.svg';
import svg34 from './assets/svg/34.svg';

const Three = () => (
	  <section>
		<div className="section-num" style={{top: 0}}>6</div>
		<p><img src={pic31} alt="" /></p>
		<div className="wrapper">
			<h2>Přírodní<br />lékárna</h2>
			<p className="like-h3">Už naši předci věděli, že stromy jsou plné léčivých látek.</p>
			<p className="txt-right" style={{marginBottom: ".75em"}}>
				<span className="relative inline-block" style={{maxWidth: "14.75em"}}>K hojení ran se i v současnosti používá odvar z dubové kůry. Od bolesti kloubů uleví mast z plodů jírovce maďalu. Čaj z lipových květů pomůže při nachlazení.
					<img src={svg31} className="pointer" style={{top: "90%", right: "70%", maxWidth: "20%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic32} alt="" /></p>
		<div className="wrapper">
			<p style={{marginTop: "-1em"}}>
				<span className="relative inline-block" style={{maxWidth: "14.5em"}}>Jedlé oříšky a ovoce ze stromů jsou pro&nbsp;naše tělo důležitým zdrojem minerálů, vitamínů a vlákniny.
					<img src={svg32} className="pointer" style={{bottom: "80%", left: "90%", maxWidth: "60px"}} alt="" />
				</span>
			</p>
			<h2>Čistí vzduch</h2>
			<p className="like-h3">Nikdo nechce dýchat vzduch plný jedovatých látek a prachových částic. Stromy nám s jeho čištěním dokáží pomoct.</p>
			<p className="txt-right" style={{marginBottom: "1em"}}>
				<span className="relative inline-block" style={{maxWidth: "13.25em"}}>Na listech a jehlicích stromů se&nbsp;každoročně zachytí obrovské množství nečistot. Ty se však s každým deštěm smyjí a dostanou se do půdy, kde dojde k jejich rozkladu.
					<img src={svg11} className="pointer" style={{top: "70%", right: "98%", maxWidth: "25%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic33} alt="" /></p>
		<div className="wrapper">
			<p style={{marginTop: "-1.25em"}}>
				<span className="relative inline-block" style={{maxWidth: "16.5em"}}>Spalováním dřeva, uhlí a ropy se do ovzduší uvolňuje oxid uhličitý. Jeho vzrůstající množství v&nbsp;atmosféře se podílí na globální změně klimatu. Stromy tuto změnu dokáží zpomalit. Během fotosyntézy totiž pohlcují oxid uhličitý ze vzduchu a zabudovávají ho do svých těl.
					<img src={svg34} className="pointer" style={{bottom: "100%", right: "4%", maxWidth: "22%"}} alt="" />
				</span>
			</p>
			<h2>Nabízí<br />spojení</h2>
			<p className="like-h3">Zvuk lesa nás uklidňuje. Přirozeně v&nbsp;něm zpomalíme, srdce nám bije pravidelněji, vědomí se rozšíří.</p>
			<p className="txt-right">
				<span className="relative inline-block" style={{maxWidth: "14em"}}>V Japonsku je léčba stromy uznávaná jako součást preventivní medicíny. Lesní procházky zvané shinrin-yoku vedou prokazatelně ke snížení krevního tlaku, posílení imunity a zlepšení nálady.
					<img src={svg15} className="pointer" style={{top: "100%", right: "85%", maxWidth: "10%"}} alt="" />
				</span>
			</p>
		</div>
		<p style={{margin: "-.75em 0 .75em"}}><img src={pic34} alt="" /></p>
		<div className="wrapper">
			<p><b className="tip">Tip pro tebe:</b> Když jsi v lese, zhluboka dýchej. Do těla budeš vstřebávat tzv. rostlinná antibiotika, které stromy přirozeně uvolňují do vzduchu. Chrání se tím před napadením bakteriemi a&nbsp;houbami.</p>
			<p style={{maxWidth: "11.5em"}}>Po lesní lázni se ti bude lépe spát a vyčistíš si mysl od zaplněnosti.</p>
		</div>
	</section>
);

export default Three;
